import React from "react";
import styles from "./ToggleContainer.module.scss";
import { Astro_Strings } from "../../Strings";
import { toggleList } from "../../Data";

interface ToggleContainerProps {
  activeIndex: number;
  setActiveIndex: (val: number) => void;
}

const ToggleContainer = ({
  activeIndex,
  setActiveIndex,
}: ToggleContainerProps) => {
  const handleActiveIndex = (index: number) => {
    activeIndex === index ? setActiveIndex(activeIndex) : setActiveIndex(index);
  };
  return (
    <div className={styles.toggleContainer}>
      <h3>{Astro_Strings.ALSO_CHECK}</h3>
      <ul className={styles.toggleWrapper}>
        {toggleList.map((element, index) => {
          return (
            <li
              onClick={() => handleActiveIndex(index)}
              className={activeIndex === index ? `${styles.active}` : ``}
            >
              {element}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ToggleContainer;
